import { createAri, getAriConfig, toAri } from '@atlassian/jira-platform-ari';
import type { CloudId, IssueId, IssueTypeId } from '@atlassian/jira-shared-types';

export const getResourceId = (ariLikeString: string): string => {
	const ari = toAri(ariLikeString);
	if (ari === undefined) {
		throw Error('Invalid ARI');
	}
	return getAriConfig(ari).resourceId;
};

export const createIssueTypeAri = (cloudId: CloudId, issueTypeId: IssueTypeId) =>
	createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'issue-type',
		resourceId: issueTypeId,
	});

export const createIssueAri = (cloudId: CloudId, issueId: IssueId) =>
	createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'issue',
		resourceId: issueId,
	});
